import useAPI from "./useAPI";

export default function useSourceCode() {
  const api = useAPI();

  const adminSourceCodes = async () => {
    return await api.getAdminSourceCodes();
  };

  const adminSourceCodeByName = async (name) => {
    return await api.getAdminSourceCode(name);
  };

  const adminCreateSourceCode = async ({ name, content }) => {
    return await api.createAdminSourceCode({ name, content });
  };

  const adminUpdateSourceCode = async (name, { content }) => {
    return await api.updateAdminSourceCode(name, { content });
  };

  const adminDeleteSourceCode = async (name) => {
    return await api.deleteAdminSourceCode(name);
  };

  const adminDeploySource = async (name, { chainId, constructorArguments }) => {
    return await api.deployAdminSource(name, { chainId, constructorArguments });
  };

  return {
    adminSourceCodes,
    adminSourceCodeByName,
    adminCreateSourceCode,
    adminUpdateSourceCode,
    adminDeleteSourceCode,
    adminDeploySource,
  };
}
